import { Navbar } from "./Navbar";
import { Header, Footer } from "@cakrawalajakarta/shared-components";
import { Outlet, useLocation } from "react-router-dom";

export const Layout = () => {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase();

  const shouldHideFooter = [
    "/login", 
    "/lupapassword", 
    "/xtrifeinnie", 
    "/pesanan-detail", 
    "/verify", 
    "/register",
    path.startsWith("/detailanggota/")
  ].some(route => typeof route === 'string' ? path === route : route);

  const shouldHideNavbar = false;

  return (
    <div className="flex flex-col min-h-screen">
      {!shouldHideNavbar && (
        <div className="z-50 w-full flex justify-center">
          <Navbar />
        </div>
      )}

      <div className="w-full flex justify-center">
        <Header />
      </div>

      <main className="flex-grow">
        <Outlet />
      </main>

      {!shouldHideFooter && (
        <div className="w-full">
          <Footer />
        </div>
      )}
    </div>
  );
};
